import { gql } from 'graphql.macro'
import ModelFragment from '../../../lib/ModelFragment'

export default gql`
  mutation DeleteModel($id: ID!) {
    deleteModel(id: $id) {
      ...ModelFragment
    }
  }

  ${ModelFragment}
`
